import * as React from 'react';


function PageMobileContent({ children }, props) {
  const Class = `m__cont ` + (props.className ? props.className : '');
  return (
    <div className={Class}>
      {children}
    </div>
  );
}

export default PageMobileContent as any;
